module.exports = __webpack_public_path__ + "static/media/lock_icon.de85f637.svg";